module.exports = __webpack_public_path__ + "media/images/icons/filled/file-unknown-54e5d4dafcd22f37a1d0b8c4b956612d.svg";